import React from 'react';

const STATUS_CONTENT = {
  active: {
    labelKey: 'Dashboard_Status_Active_Label',
    fallbackKey: 'Dashboard_Status_Active_Fallback',
  },
  oneOff: {
    labelKey: 'Dashboard_Status_OneOff_Label',
    fallbackKey: 'Dashboard_Status_OneOff_Fallback',
    ctaKey: 'Dashboard_Status_OneOff_Cta',
  },
  cancelled: {
    labelKey: 'Dashboard_Status_Cancelled_Label',
    fallbackKey: 'Dashboard_Status_Cancelled_Fallback',
    ctaKey: 'Dashboard_Status_Cancelled_Cta',
  },
};

function normalizeOrderStatus(status) {
  return String(status || '').trim().toLowerCase();
}

function isPreparingOrderStatus(status) {
  const normalizedStatus = normalizeOrderStatus(status);
  return normalizedStatus === 'pending' || normalizedStatus === 'ready to dispatch';
}

function getCustomerOrderStatusLabel(status, t) {
  const normalizedStatus = normalizeOrderStatus(status);
  const statusKey = normalizedStatus.replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

  return t(`Dashboard_Status_Order_${statusKey}`, status);
}

const DashboardStatusLine = ({ customerType, currentOrder, displayDate, onAction, t }) => {
  const content = STATUS_CONTENT[customerType] || STATUS_CONTENT.active;
  const shouldShowCurrentOrder = customerType === 'active' && currentOrder?.status;
  const currentOrderStatusLabel = shouldShowCurrentOrder
    ? getCustomerOrderStatusLabel(currentOrder.status, t)
    : '';
  const shouldShowTracking = shouldShowCurrentOrder && !isPreparingOrderStatus(currentOrder.status);

  return (
    <section className="t-flex t-flex-col t-gap-4 t-rounded-[14px] t-border t-border-g200 t-bg-white t-px-5 t-py-4 md:t-flex-row md:t-items-center md:t-justify-between md:t-px-6">
      <div className="t-flex t-flex-col t-gap-1">
        {shouldShowCurrentOrder ? (
          <>
            <p className="t-m-0 t-text-sm t-font-bold t-text-navy md:t-text-[15px]">
              {t('Dashboard_Status_CurrentOrder_Label')}{' '}
              <span className="t-font-medium t-text-teal-muted">{currentOrderStatusLabel}</span>
            </p>
            {shouldShowTracking && currentOrder.trackingLink ? (
              <a
                className="t-text-sm t-font-semibold t-text-secondary hover:t-text-secondary/80"
                href={currentOrder.trackingLink}
                target="_blank"
                rel="noreferrer"
              >
                {t('Dashboard_Status_Tracking_Link')}
              </a>
            ) : null}
          </>
        ) : (
          <p className="t-m-0 t-text-sm t-font-bold t-text-navy md:t-text-[15px]">
            {t(content.labelKey)}{' '}
            <span className="t-font-medium t-text-teal-muted">{displayDate || t(content.fallbackKey)}</span>
          </p>
        )}
      </div>
      {content.ctaKey && (
        <button
          type="button"
          className="t-w-full t-rounded-full t-border-0 t-bg-navy t-px-5 t-py-2.5 t-text-sm t-font-bold t-text-white md:t-w-auto"
          onClick={onAction}
        >
          {t(content.ctaKey)}
        </button>
      )}
    </section>
  );
};

export default DashboardStatusLine;
